// components/Footer.jsx

import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

export default function Footer() {
  const hostname = window.location.hostname;

  const isNotesSite =
    hostname === 'mysimpledbnotes.com' ||
    hostname === 'www.mysimpledbnotes.com';

  const productName = isNotesSite
    ? 'MySimpleDB Notes'
    : 'MySimpleDB';

  return (
    <footer className="site-footer">
      <div className="site-footer-content">
        <div className="site-footer-brand">
          {productName}
        </div>

        <nav className="site-footer-links" aria-label="Footer navigation">
          {isNotesSite && (
            <Link to="/downloads">Downloads</Link>
          )}

          <Link to="/help">Help & Support</Link>
          <Link to="/contact">Contact Us</Link>
          <Link to="/privacy">Privacy</Link>
          <Link to="/terms">Terms</Link>
          <Link to="/about">About</Link>
        </nav>

        <div className="site-footer-copyright">
          © {new Date().getFullYear()} {productName}. All rights reserved.
        </div>
      </div>
    </footer>
  );
}
